import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Flex,
  // Menu as MenuCha,
  IconButton,
} from "@chakra-ui/react";

// import {
//   AccordionItem,
//   AccordionItemContent,
//   AccordionItemTrigger,
//   AccordionRoot,
// } from "./ui/accordion";
// import { ImageBasic } from "./Image";
// import useCheckMobileScreen from "hooks/useCheckMobileScreen";
// import { IoIosArrowDown } from "react-icons/io";
import { FaRegListAlt } from "react-icons/fa";

// import {
//   DrawerBackdrop,
//   DrawerBody,
//   DrawerCloseTrigger,
//   DrawerContent,
//   DrawerHeader,
//   DrawerRoot,
//   DrawerTitle,
//   DrawerTrigger,
// } from "./ui/drawer";
// import { setUserData } from "../redux";
// import { useDispatch } from "react-redux";

import { IoStatsChartSharp } from "react-icons/io5";
import { Tooltip } from "./ui/tooltip";

import SvgIcAccounts from "../assets/svg/SvgIcAccounts.jsx";
import SvgIcAgreements from "../assets/svg/SvgIcAgreements.jsx";
// import SvgIcBuildmyplan from "../assets/svg/SvgIcBuildmyplan.jsx";
import SvgIcClaims from "../assets/svg/SvgIcClaims.jsx";
import SvgIcDocuments from "../assets/svg/SvgIcDocuments.jsx";
import SvgIcHome from "../assets/svg/SvgIcHome.jsx";
import SvgIcInvoices from "../assets/svg/SvgIcInvoices.jsx";
import SvgIcManage from "../assets/svg/SvgIcManage.jsx";

// const IcHome = (
//   <svg
//     stroke="currentColor"
//     fill="currentColor"
//     stroke-width="0"
//     viewBox="0 0 24 24"
//     aria-hidden="true"
//     focusable="false"
//     height="24px"
//     width="24px"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path fill="none" d="M0 0h24v24H0z"></path>
//     <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"></path>
//   </svg>
// );

// const IcUsers = (
//   <svg
//     stroke="currentColor"
//     fill="currentColor"
//     stroke-width="0"
//     viewBox="0 0 24 24"
//     aria-hidden="true"
//     focusable="false"
//     height="24px"
//     width="24px"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path fill="none" d="M0 0h24v24H0z"></path>
//     <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm0 14c-2.03 0-4.43-.82-6.14-2.88a9.947 9.947 0 0 1 12.28 0C16.43 19.18 14.03 20 12 20z"></path>
//   </svg>
// );

// const IcRoles = (
//   <svg
//     stroke="currentColor"
//     fill="currentColor"
//     stroke-width="0"
//     viewBox="0 0 24 24"
//     aria-hidden="true"
//     focusable="false"
//     height="24px"
//     width="24px"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path fill="none" d="M0 0h24v24H0z"></path>
//     <path d="M17 11c.34 0 .67.04 1 .09V6.27L10.5 3 3 6.27v4.91c0 4.54 3.2 8.79 7.5 9.82.55-.13 1.08-.32 1.6-.55-.69-.98-1.1-2.17-1.1-3.45 0-3.31 2.69-6 6-6z"></path>
//     <path d="M17 13c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 1.38c.62 0 1.12.51 1.12 1.12s-.51 1.12-1.12 1.12-1.12-.51-1.12-1.12.5-1.12 1.12-1.12zm0 5.37c-.93 0-1.74-.46-2.24-1.17.05-.72 1.51-1.08 2.24-1.08s2.19.36 2.24 1.08c-.5.71-1.31 1.17-2.24 1.17z"></path>
//   </svg>
// );

// const IcCustomers = (
//   <svg
//     stroke="currentColor"
//     fill="currentColor"
//     stroke-width="0"
//     viewBox="0 0 24 24"
//     aria-hidden="true"
//     focusable="false"
//     height="24px"
//     width="24px"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path fill="none" d="M0 0h24v24H0V0z"></path>
//     <path d="M9 13.75c-2.34 0-7 1.17-7 3.5V19h14v-1.75c0-2.33-4.66-3.5-7-3.5zM4.34 17c.84-.58 2.87-1.25 4.66-1.25s3.82.67 4.66 1.25H4.34zM9 12c1.93 0 3.5-1.57 3.5-3.5S10.93 5 9 5 5.5 6.57 5.5 8.5 7.07 12 9 12zm0-5c.83 0 1.5.67 1.5 1.5S9.83 10 9 10s-1.5-.67-1.5-1.5S8.17 7 9 7zm7.04 6.81c1.16.84 1.96 1.96 1.96 3.44V19h4v-1.75c0-2.02-3.5-3.17-5.96-3.44zM15 12c1.93 0 3.5-1.57 3.5-3.5S16.93 5 15 5c-.54 0-1.04.13-1.5.35.63.89 1 1.98 1 3.15s-.37 2.26-1 3.15c.46.22.96.35 1.5.35z"></path>
//   </svg>
// );

// const IcVehicles = (
//   <svg
//     stroke="currentColor"
//     fill="currentColor"
//     stroke-width="0"
//     viewBox="0 0 24 24"
//     aria-hidden="true"
//     focusable="false"
//     height="24px"
//     width="24px"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path fill="none" d="M0 0h24v24H0z"></path>
//     <path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"></path>
//   </svg>
// );

// const IcSites = (
//   <svg
//     stroke="currentColor"
//     fill="currentColor"
//     stroke-width="0"
//     viewBox="0 0 24 24"
//     aria-hidden="true"
//     focusable="false"
//     height="24px"
//     width="24px"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path fill="none" d="M0 0h24v24H0z"></path>
//     <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5z"></path>
//   </svg>
// );

// const IcNotifications = (
//   <svg
//     stroke="currentColor"
//     fill="currentColor"
//     stroke-width="0"
//     viewBox="0 0 24 24"
//     aria-hidden="true"
//     focusable="false"
//     height="24px"
//     width="24px"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path d="M12 22c1.1 0 2-.9 2-2h-4a2 2 0 0 0 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"></path>
//   </svg>
// );

// const IcSubscriptions = (
//   <svg
//     stroke="currentColor"
//     fill="currentColor"
//     stroke-width="0"
//     viewBox="0 0 24 24"
//     aria-hidden="true"
//     focusable="false"
//     height="24px"
//     width="24px"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path fill="none" d="M0 0h24v24H0z"></path>
//     <path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"></path>
//   </svg>
// );

// const IcTenants = (
//   <svg
//     stroke="currentColor"
//     fill="currentColor"
//     stroke-width="0"
//     viewBox="0 0 24 24"
//     aria-hidden="true"
//     focusable="false"
//     height="24px"
//     width="24px"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path fill="none" d="M0 0h24v24H0z"></path>
//     <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"></path>
//   </svg>
// );

// v3
const items = [
  { id: "home", label: "Home", route: "home", ic: SvgIcHome },
  {
    id: "accounts",
    label: "Accounts",
    route: "status",
    ic: SvgIcAccounts,
    items: [
      {
        id: "status",
        label: "Status",
        route: "status",
        ic: FaRegListAlt,
      },
      {
        id: "statements",
        label: "Statements",
        route: "statements",
        ic: IoStatsChartSharp,
      },
    ],
  },
  {
    id: "agreements",
    label: "Agreements",
    route: "agreements",
    ic: SvgIcAgreements,
  },
  { id: "claims", label: "Claims", route: "claims", ic: SvgIcClaims },
  { id: "invoices", label: "Invoices", route: "invoices", ic: SvgIcInvoices },
  {
    id: "documents",
    label: "Documents",
    route: "documents",
    ic: SvgIcDocuments,
  },

  // {
  //   id: "buildmyplan",
  //   label: "Build My Plan",
  //   route: "",
  //   ic: SvgIcBuildmyplan,
  // },
  { id: "manage", label: "Manage", route: "manage", ic: SvgIcManage },

  // { id: "Roles", label: "Roles", route: "", ic: IcRoles },
  // { id: "Customers", label: "Customers", route: "", ic: IcCustomers },
  // { id: "Vehicles", label: "Vehicles", route: "", ic: IcVehicles },
  // { id: "Sites", label: "Sites", route: "", ic: IcSites },
  // {
  //   id: "Notifications",
  //   label: "Notifications",
  //   route: "",
  //   ic: IcNotifications,
  // },
  // {
  //   id: "Subscriptions",
  //   label: "Subscriptions",
  //   route: "",
  //   ic: IcSubscriptions,
  // },
  // { id: "Tenants", label: "Tenants", route: "", ic: IcTenants },
];

// const itemsX = [
//   {
//     id: "home",
//     label: "Home",
//     route: "home",
//   },
//   {
//     id: "accounts",
//     label: "Accounts",
//     route: "accounts",
//     items: [
//       {
//         id: "status",
//         route: "status",
//         label: "Status",
//         child: true,
//         parentid: "accounts",
//       },
//       {
//         id: "statements",
//         route: "statements",
//         label: "Statements",
//         child: true,
//         parentid: "accounts",
//       },
//     ],
//   },
//   {
//     id: "agreements",
//     label: "Agreements",
//     route: "agreements",
//   },
//   {
//     id: "claims",
//     label: "Claims",
//     route: "claims",
//   },
//   {
//     id: "invoices",
//     label: "Invoices",
//     route: "invoices",
//   },
//   {
//     id: "documents",
//     label: "Documents",
//     route: "documents",
//   },
//   // {
//   //   id: "buildplan",
//   //   label: "Build My Plan",
//   //   route: "",
//   // },

//   {
//     id: "manage",
//     label: "Manage",
//     route: "manage",
//     items: [
//       // {
//       //   id: "managecar",
//       //   route: "managecar",
//       //   label: "Cars",
//       //   child: true,
//       //   parentid: "manage",
//       // },
//       {
//         id: "manageusers",
//         route: "manageusers",
//         label: "Users",
//         child: true,
//         parentid: "manage",
//       },
//       {
//         id: "managegroups",
//         route: "managegroups",
//         label: "Groups",
//         child: true,
//         parentid: "manage",
//       },
//       {
//         id: "return",
//         route: "return",
//         label: "View Returns",
//         child: true,
//         parentid: "manage",
//       },
//       {
//         id: "pricing",
//         route: "pricing",
//         label: "Pricing & Refunds",
//         child: true,
//         parentid: "manage",
//       },
//       // {
//       //   id: "custompricingrules",
//       //   route: "custompricingrules",
//       //   label: "Custom Pricing Rules",
//       //   child: true,
//       //   parentid: "manage",
//       // },
//       // {
//       //   id: "custompricing",
//       //   route: "custompricing",
//       //   label: "Generate Custom Pricing",
//       //   child: true,
//       //   parentid: "manage",
//       // },
//       {
//         id: "commissionsheets",
//         route: "commissionsheets",
//         label: "Commission Sheets",
//         child: true,
//         parentid: "manage",
//       },
//       {
//         id: "commissionrules",
//         route: "commissionrules",
//         label: "Commission Rules",
//         child: true,
//         parentid: "manage",
//       },
//       {
//         id: "policies",
//         route: "policies",
//         label: "Policies",
//         child: true,
//         parentid: "manage",
//       },
//       {
//         id: "duration",
//         route: "duration",
//         label: "Duration",
//         child: true,
//         parentid: "manage",
//       },
//       {
//         id: "covertypes",
//         route: "covertypes",
//         label: "Cover Types",
//         child: true,
//         parentid: "manage",
//       },
//       {
//         id: "claimlimits",
//         route: "claimlimits",
//         label: "Claim Limits",
//         child: true,
//         parentid: "manage",
//       },
//       // {
//       //   id: "vat",
//       //   route: "vat",
//       //   label: "VAT",
//       //   child: true,
//       //   parentid: "manage",
//       // },
//       // {
//       //   id: "permissionprofiles",
//       //   route: "permissionprofiles",
//       //   label: "Persmissions",
//       //   child: true,
//       //   parentid: "manage",
//       // },
//       {
//         id: "paymentsout",
//         route: "paymentsout",
//         label: "Payments Out",
//         child: true,
//         parentid: "manage",
//       },
//       {
//         id: "paymentsreceived",
//         route: "paymentsreceived",
//         label: "Payments In",
//         child: true,
//         parentid: "manage",
//       },
//       // {
//       //   id: "coveredparts",
//       //   route: "coveredparts",
//       //   label: "Covered Parts",
//       //   child: true,
//       //   parentid: "manage",
//       // },
//       {
//         id: "schedule",
//         route: "schedule",
//         label: "Schedule",
//         child: true,
//         parentid: "manage",
//       },
//     ],
//   },
//   {
//     id: "settings",
//     label: "Settings",
//     route: "settings",
//     items: [
//       {
//         id: "vat",
//         route: "vat",
//         label: "VAT",
//         child: true,
//         parentid: "settings",
//       },
//       {
//         id: "permissionprofiles",
//         route: "permissionprofiles",
//         label: "Persmissions",
//         child: true,
//         parentid: "settings",
//       },
//     ],
//   },
// ];

const MenuContentV3 = () => {
  const { pathname } = useLocation();
  // const [active, setActive] = useState(pathname?.substring(1));
  // const [activeId, setActiveId] = useState();
  const [activePr, setActivePr] = useState();
  const [activeCr, setActiveCr] = useState();

  const navigate = useNavigate();
  // const dispatch = useDispatch();

  // const [userDataL, setUseDataL] = useState(() => {
  //   let loginRes = window.localStorage.getItem("loginRes");
  //   loginRes = loginRes ? JSON.parse(loginRes) : {};
  //   return loginRes;
  // });

  // const onLogout = () => {
  //   dispatch(setUserData({}));
  //   api.logout().then((res) => {
  //         console.log("logout res", res);
  //         dispatch(setUserData({}));
  //         localStorage.clear();
  //       });
  // };

  // const onChangeUserTab = (data) => {
  //   if (data?.action === "logout") {
  //     onLogout();
  //   }
  // };

  const onMenuChange = (data) => {
    console.log("onMenuChange", data);

    if (!data.route) {
      return;
    }
    if (data?.items && data?.items[0]?.route) {
      // setActive(data.route);
      navigate(`/${data.items[0].route}`);
      return;
    }
    // setActive(data.route);
    navigate(`/${data.route}`);
    // setOpen && setOpen(false);
  };

  useEffect(() => {
    if (items && items[0]) {
      const aroute = pathname?.substring(1);
      items?.forEach((a) => {
        if (a?.items && a?.items[0]) {
          a?.items.forEach((b) => {
            if (b.id === aroute) {
              setActivePr(a.route);
              setActiveCr(b?.route);
              return;
            }
          });
          return;
        } else if (a?.route === aroute) {
          setActivePr(a?.route);
          setActiveCr();
          return;
        }
      });
    }
  }, [pathname]);

  // if (
  //   pathname === "" ||
  //   pathname?.substring(1) === "" ||
  //   pathname?.substring(1) === "forgotpassword"
  // ) {
  //   return null;
  // }

  return (
    <Flex direction={"column"} p={"1rem"} pr={"0px"}>
      {items?.map((item) => {
        // if (item.items) {
        //   return (
        //     <Flex
        //       bg={activePr === item?.route ? "white" : "transparent"}
        //       p={"2px"}
        //     >
        //       <MenuCha.Root
        //         onSelect={(e) =>
        //           onMenuChange({ route: e?.value, id: item?.id })
        //         }
        //       >
        //         <MenuCha.Trigger>
        //           <Button
        //             borderRadius={"0px"}
        //             variant="plain"
        //             size="xs"
        //             fontSize={"md"}
        //             color={activePr === item?.route ? "primary" : "white"}
        //             px={"1rem"}
        //           >
        //             {item?.label} <IoIosArrowDown />
        //           </Button>
        //         </MenuCha.Trigger>
        //         <Portal>
        //           <MenuCha.Positioner>
        //             <MenuCha.Content bg={"primary"}>
        //               <For each={item?.items || []}>
        //                 {(itemC) => (
        //                   <MenuCha.Item
        //                     value={itemC?.route}
        //                     color={
        //                       activeCr === itemC.route ? "primary" : "white"
        //                     }
        //                     bg={
        //                       activeCr === itemC.route
        //                         ? "white"
        //                         : "transparent"
        //                     }
        //                   >
        //                     {itemC?.label}
        //                   </MenuCha.Item>
        //                 )}
        //               </For>
        //             </MenuCha.Content>
        //           </MenuCha.Positioner>
        //         </Portal>
        //       </MenuCha.Root>
        //     </Flex>
        //   );
        // }

        if (
          // (item?.route === "status" || item?.route === "statements") &&
          item?.id === "accounts" &&
          (activeCr === "status" || activeCr === "statements")
        ) {
          return (
            <Flex
              key={item?.id}
              direction={"column"}
              borderColor={"primary"}
              borderWidth={"2px"}
              borderRadius={"5px"}
            >
              <Flex p={"0.2rem"}>
                <Tooltip
                  showArrow
                  content={"Status"}
                  positioning={{ placement: "right-end" }}
                  openDelay={300}
                  closeDelay={20}
                  // contentProps={{
                  //   css: {
                  //     // "--tooltip-bg": "card.tooltip",
                  //     // "--tooltip-color": "white",
                  //   },
                  // }}
                  size={"lg"}
                >
                  <IconButton
                    variant={"ghost"}
                    color={activeCr === "status" ? "white" : "primary"}
                    bg={activeCr === "status" ? "primary" : "gray.100"}
                    onClick={() => onMenuChange({ route: "status" })}
                  >
                    {item?.ic ? <FaRegListAlt fill={"currentColor"} /> : null}
                    {item.activeCr}
                  </IconButton>
                </Tooltip>
              </Flex>

              <Flex p={"0.2rem"}>
                <Tooltip
                  showArrow
                  content={"Statements"}
                  positioning={{ placement: "right-end" }}
                  openDelay={300}
                  closeDelay={20}
                  // contentProps={{ css: { "--tooltip-bg": "colors.primary" } }}
                  size={"lg"}
                >
                  <IconButton
                    variant={"ghost"}
                    color={activeCr === "statements" ? "white" : "primary"}
                    bg={activeCr === "statements" ? "primary" : "gray.100"}
                    onClick={() => onMenuChange({ route: "statements" })}
                  >
                    {item?.ic ? (
                      <IoStatsChartSharp fill={"currentColor"} />
                    ) : null}
                    {item.activeCr}
                  </IconButton>
                </Tooltip>
              </Flex>
            </Flex>
          );
        }
        return (
          <Flex
            key={item?.id}
            // bg={activePr === item?.route ? "white" : "transparent"}
            p={"0.2rem"}
          >
            <Tooltip
              showArrow
              content={item.label}
              positioning={{ placement: "right-end" }}
              openDelay={300}
              closeDelay={20}
              // contentProps={{ css: { "--tooltip-bg": "colors.primary" } }}
              size={"lg"}
            >
              <IconButton
                // size={"xs"}
                // fontSize={"md"}
                // borderRadius={"0px"}
                // px={"1rem"}
                // py={"5px"}
                // m={"opx"}
                variant={"ghost"}
                // variant={activePr === item?.route ? "solid" : "subtle"}
                color={activePr === item?.route ? "white" : "primary"}
                bg={activePr === item?.route ? "primary" : "gray.100"}
                onClick={() => onMenuChange(item)}
              >
                {item?.ic ? <item.ic fill={"currentColor"} /> : null}
                {/* <svg fill="blue.500">{item.ic}</svg> */}
                {/* {item?.ic ? (
                  <ImageBasic
                    src={item.ic}
                    // alignSelf={"center"}
                    // p={"1rem"}/
                    // ml={"1rem"}
                    // color={activePr === item?.route ? "red" : "blue"}
                    // w={"2rem"}variant={activePr === item?.route ? "solid" : "subtle"}
                    // fill={activePr === item?.route ? "red" : "blue"}
                    // bg={activePr === item?.route ? "primary" : "gray.100"}
                    // fillcolor='red'
                    // fill={activePr === item?.route ? "red" : "blue"}
                    filter={
                      "brightness(0.7) sepia(4) hue-rotate(-72deg) saturate(6)"
                    }
                  />
                ) : null} */}
                {item.activePr}
              </IconButton>
            </Tooltip>
          </Flex>
        );
      })}
      {/* <For each={items}>
        {(item)}
      </For> */}
    </Flex>
  );
};

// const MenuContentV2 = () => {
//   const { pathname } = useLocation();
//   const [active, setActive] = useState(pathname?.substring(1));
//   const [activeId, setActiveId] = useState();
//   const [activePr, setActivePr] = useState();
//   const [activeCr, setActiveCr] = useState();

//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [userDataL, setUseDataL] = useState(() => {
//     let loginRes = window.localStorage.getItem("loginRes");
//     loginRes = loginRes ? JSON.parse(loginRes) : {};
//     return loginRes;
//   });

//   const onLogout = () => {
//     dispatch(setUserData({}));
//   };

//   const onChangeUserTab = (data) => {
//     if (data?.action === "logout") {
//       onLogout();
//     }
//   };

//   const onMenuChange = (data) => {
//     console.log("onMenuChange", data);

//     if (!data.route) {
//       return;
//     }
//     if (data.items && data.items[0]) {
//       // setActive(data.route);
//       return;
//     }
//     setActive(data.route);
//     navigate(`/${data.route}`);
//     // setOpen && setOpen(false);
//   };

//   useEffect(() => {
//     if (items && items[0]) {
//       const aroute = pathname?.substring(1);
//       items?.forEach((a) => {
//         if (a?.items && a?.items[0]) {
//           a?.items.forEach((b) => {
//             if (b.id === aroute) {
//               setActivePr(a.route);
//               setActiveCr(b?.route);
//               return;
//             }
//           });
//           return;
//         } else if (a?.route === aroute) {
//           setActivePr(a?.route);
//           setActiveCr();
//           return;
//         }
//       });
//     }
//   }, [pathname]);

//   // if (
//   //   pathname === "" ||
//   //   pathname?.substring(1) === "" ||
//   //   pathname?.substring(1) === "forgotpassword"
//   // ) {
//   //   return null;
//   // }

//   return (
//     <Flex direction={"column"}>
//       <ImageBasic
//         // alignSelf={"center"}
//         p={"1rem"}
//         ml={"1rem"}
//         src={"./img/img-brand-logo-dark.png"}
//         w={"8rem"}
//       />
//       <Flex
//         bg={"primary"}
//         px={"1rem"}
//         justify={"space-between"}
//         alignItems={"center"}
//         overflowX={"auto"}
//       >
//         <Flex alignItems={"center"}>
//           <For each={items}>
//             {(item) => {
//               if (item.items) {
//                 return (
//                   <Flex
//                     bg={activePr === item?.route ? "white" : "transparent"}
//                     p={"2px"}
//                   >
//                     <MenuCha.Root
//                       onSelect={(e) =>
//                         onMenuChange({ route: e?.value, id: item?.id })
//                       }
//                     >
//                       <MenuCha.Trigger>
//                         <Button
//                           borderRadius={"0px"}
//                           variant="plain"
//                           size="xs"
//                           fontSize={"md"}
//                           color={activePr === item?.route ? "primary" : "white"}
//                           px={"1rem"}
//                         >
//                           {item?.label} <IoIosArrowDown />
//                         </Button>
//                       </MenuCha.Trigger>
//                       <Portal>
//                         <MenuCha.Positioner>
//                           <MenuCha.Content bg={"primary"}>
//                             <For each={item?.items || []}>
//                               {(itemC) => (
//                                 <MenuCha.Item
//                                   value={itemC?.route}
//                                   color={
//                                     activeCr === itemC.route
//                                       ? "primary"
//                                       : "white"
//                                   }
//                                   bg={
//                                     activeCr === itemC.route
//                                       ? "white"
//                                       : "transparent"
//                                   }
//                                 >
//                                   {itemC?.label}
//                                 </MenuCha.Item>
//                               )}
//                             </For>
//                           </MenuCha.Content>
//                         </MenuCha.Positioner>
//                       </Portal>
//                     </MenuCha.Root>
//                   </Flex>
//                 );
//               }
//               return (
//                 <Flex
//                   bg={activePr === item?.route ? "white" : "transparent"}
//                   p={"2px"}
//                 >
//                   <Button
//                     size={"xs"}
//                     fontSize={"md"}
//                     borderRadius={"0px"}
//                     px={"1rem"}
//                     // py={"5px"}
//                     // m={"opx"}
//                     variant={"ghost"}
//                     color={activePr === item?.route ? "primary" : "white"}
//                     // bg={item.id === active ? "white" : "transparent"}
//                     onClick={() => onMenuChange(item)}
//                   >
//                     {item.label}
//                   </Button>
//                 </Flex>
//               );
//             }}
//           </For>
//         </Flex>
//         <Flex>
//           {/* <ColorModeButton/> */}
//           <MenuCha.Root onSelect={(e) => onChangeUserTab({ action: e.value })}>
//             <MenuCha.Trigger asChild>
//               <Button
//                 size={"xs"}
//                 fontSize={"md"}
//                 variant="plain"
//                 color={"white"}
//                 // fontWeight={"bold"}
//               >
//                 {`${userDataL?.firstname || ""} ${userDataL?.lastname || ""}`}{" "}
//                 <IoIosArrowDown />
//               </Button>
//             </MenuCha.Trigger>
//             <Portal>
//               <MenuCha.Positioner>
//                 <MenuCha.Content>
//                   <MenuCha.Item value="logout">Logout</MenuCha.Item>
//                 </MenuCha.Content>
//               </MenuCha.Positioner>
//             </Portal>
//           </MenuCha.Root>
//         </Flex>
//       </Flex>
//     </Flex>
//   );
// };

// const MenuContent = ({ setOpen }) => {
//   const { pathname } = useLocation();
//   const [active, setActive] = useState(pathname?.substring(1));
//   const [userDataL, setUseDataL] = useState(() => {
//     let loginRes = window.localStorage.getItem("loginRes");
//     loginRes = loginRes ? JSON.parse(loginRes) : {};
//     return loginRes;
//   });
//   const [defaultValueA, setDefaultValueA] = useState(() => {
//     let res = [];
//     if (items && items[0]) {
//       items.forEach((a) => {
//         if (a.items && a.items[0]) {
//           a.items.forEach((b) => {
//             if (b.route === pathname?.substring(1)) {
//               res = [b.parentid, b.route];
//             }
//           });
//         } else {
//           if (a.route === pathname?.substring(1)) {
//             res = [a.route];
//           }
//         }
//       });
//     }
//     return res;
//   });
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const ismobile = useCheckMobileScreen();

//   if (
//     pathname === "" ||
//     pathname?.substring(1) === "" ||
//     pathname?.substring(1) === "forgotpassword" ||
//     pathname?.substring(1) === "resetpassword"
//   ) {
//     return <Flex></Flex>;
//   }

//   const handleMenuChange = (data) => {
//     console.log(data);

//     if (!data.route) {
//       return;
//     }
//     if (data.items && data.items[0]) {
//       // setActive(data.route);
//       return;
//     }
//     setActive(data.route);
//     navigate(`/${data.route}`);
//     setOpen && setOpen(false);
//   };

//   const onLogout = () => {
//     dispatch(setUserData({}));
//   };

//   return (
//     <Flex
//       direction={"column"}
//       // overflow={"scroll"}
//       h={"100%"}
//       // h={ismobile ? "100%" : "100vh"}
//       // w={ismobile ? "100%" : "300px"}
//       minW={ismobile ? "100%" : "300px"}
//       overflow={"hidden"}
//       bg="primary"
//       overflowY={"scroll"}
//     >
//       <ImageBasic
//         h="150px"
//         alignSelf={"center"}
//         p={"30px"}
//         src="./img/img-brand-logo.png"
//       />
//       <AccordionRoot
//         // value={active}
//         collapsible
//         defaultValue={defaultValueA}
//       >
//         <For each={items}>
//           {(item) => (
//             <AccordionItem
//               bg={item.id === active ? "white" : "primary"}
//               key={item.id}
//               value={item.id}
//             >
//               <AccordionItemTrigger
//                 h={10}
//                 p={2}
//                 onClick={() => handleMenuChange(item)}
//               >
//                 <Flex
//                   bg={"transparent"}
//                   color={item.id === active ? "primary" : "white"}
//                   fontSize={"xl"}
//                   w={"100%"}
//                   justifyContent={"flex-start"}
//                 >
//                   {item.label}
//                 </Flex>
//               </AccordionItemTrigger>
//               <For each={item?.items}>
//                 {(item2) => (
//                   <AccordionItemContent
//                     key={item2.id}
//                     bg={item2.id === active ? "white" : "primary"}
//                     h={10}
//                     p={2}
//                     onClick={() => handleMenuChange(item2)}
//                   >
//                     <Flex
//                       h={4}
//                       w={"100%"}
//                       bg={"transparent"}
//                       color={item2.id === active ? "primary" : "white"}
//                       justifyContent={"flex-start"}
//                       pl={"1rem"}
//                     >
//                       {item2.label}
//                     </Flex>
//                   </AccordionItemContent>
//                 )}
//               </For>
//             </AccordionItem>
//           )}
//         </For>
//       </AccordionRoot>
//       <Flex flex="1" alignItems="flex-end">
//         <Flex
//           direction="row"
//           justifyContent="space-between"
//           alignItems="center"
//           bg="white"
//           width="100%"
//           p="2"
//           borderTopStartRadius="1rem"
//           borderTopEndRadius="1rem"
//           mt={"2rem"}
//         >
//           <Text color="primary" textStyle="lg" fontWeight="bold">
//             {`${userDataL?.firstname || ""} ${userDataL?.lastname || ""}`}
//           </Text>
//           <Text
//             onClick={onLogout}
//             color="primary"
//             textStyle="sm"
//             fontWeight="bold"
//           >
//             Logout
//           </Text>
//         </Flex>
//       </Flex>
//       {/* </List.Root> */}
//     </Flex>
//   );
// };

const Menu = ({ type }) => {
  const { pathname } = useLocation();
  // const ismobile = useCheckMobileScreen();
  // const [open, setOpen] = useState(false);

  if (
    pathname === "" ||
    pathname?.substring(1) === "" ||
    pathname?.substring(1) === "forgotpassword" ||
    pathname?.substring(1) === "resetpassword"
  ) {
    return null;
  }

  // if (ismobile) {
  //   return (
  //     <DrawerRoot
  //       placement="start"
  //       open={open}
  //       onOpenChange={(e) => setOpen(e.open)}
  //       size={"full"}
  //     >
  //       <DrawerBackdrop />
  //       <DrawerTrigger asChild>
  //         <Button
  //           colorPalette="primary"
  //           bg="white"
  //           variant="plain"
  //           size="sm"
  //           position={"fixed"}
  //         >
  //           <IoMenu />
  //         </Button>
  //       </DrawerTrigger>

  //       <DrawerContent bg="primary">
  //         <DrawerHeader>
  //           <DrawerTitle color={"white"}>Menu</DrawerTitle>
  //         </DrawerHeader>
  //         <DrawerBody>
  //           <MenuContent setOpen={setOpen} />
  //         </DrawerBody>
  //         {/* <DrawerFooter>
  //             <DrawerActionTrigger asChild>
  //               <Button variant="outline">Cancel</Button>
  //             </DrawerActionTrigger>
  //             <Button>Save</Button>
  //           </DrawerFooter> */}
  //         <DrawerCloseTrigger color={"white"} />
  //       </DrawerContent>
  //     </DrawerRoot>
  //   );
  // }

  return <MenuContentV3 key={"MenuContentV3"} />;

  // return (
  //   <Tabs.Root variant="enclosed" maxW="md" fitted defaultValue={"tab-1"}>
  //     <Tabs.List>
  //       <Tabs.Trigger value="tab-1">Tab 1</Tabs.Trigger>
  //       <Tabs.Trigger value="tab-2">Tab 2</Tabs.Trigger>
  //       {/* <Tabs.Trigger value="tab-3"> */}
  //       <MenuCha.Root>
  //         <MenuCha.Trigger asChild>
  //           <Button variant="outline" size="sm">
  //             Tab 3
  //           </Button>
  //         </MenuCha.Trigger>
  //         <Portal>
  //           <MenuCha.Positioner>
  //             <MenuCha.Content>
  //               <MenuCha.Item value="new-txt">New Text File</MenuCha.Item>
  //               <MenuCha.Item value="new-file">New File...</MenuCha.Item>
  //               <MenuCha.Item value="new-win">New Window</MenuCha.Item>
  //               <MenuCha.Item value="open-file">Open File...</MenuCha.Item>
  //               <MenuCha.Item value="export">Export</MenuCha.Item>
  //             </MenuCha.Content>
  //           </MenuCha.Positioner>
  //         </Portal>
  //       </MenuCha.Root>
  //       {/* </Tabs.Trigger> */}
  //     </Tabs.List>
  //   </Tabs.Root>
  // );

  // return <MenuContent />;
};

export default Menu;
